import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';
import { getAwsAuthUtil } from '../../../../main/utils/aws/aws-auth.util.ts';

import { meQueryRequest } from '../../../requests/me.query.ts';

import { setFormProfileName } from '../accounts.slice.ts';
import { ACCOUNTS_SLICE_NAME } from '../accounts.slice.types.ts';

export const prefillChildProfileFormThunk = createAsyncThunk<void, void, ThunkApiConfigType>(
  `${ACCOUNTS_SLICE_NAME}/prefillChildProfileForm`,
  async (_, thunkAPI) => {
    const isParentOrGuardian = await getAwsAuthUtil().isParentOrGuardian();
    if (isParentOrGuardian) {
      return;
    }

    const meResult = await meQueryRequest();
    if (!meResult.success) {
      return;
    }

    thunkAPI.dispatch(setFormProfileName(meResult.data.parent.preferredName));
  }
);
